function datetime(dateStr) {
  if (dateStr) {
    const date = new Date(dateStr);

    const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
    const hour = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
    const minute = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
    /* eslint-disable space-infix-ops */
    const formattedDate = `${date.getFullYear()}.${month}.${day}`;
    const formattedTime = `${hour}:${minute}`;

    return `${formattedDate} ${formattedTime}`;
  }

  return '';
}

export default datetime;



// WEBPACK FOOTER //
// ./src/filters/datetime.js